<template>
  <div class="files-block-wrap">
<!--    <div class="name-block" v-if="visibleAddFile === true">-->
<!--      <p class="" :class="classForTitle">Attachments</p>-->
<!--      <button class="blue-button-text fz13 fw500"  v-if="getPermissionsForUserCanAddFile || (editPermission !== false || addFilePermission !== false)">-->
<!--        <input type="file" multiple  id="files" ref="files" v-on:change="handleFilesUpload">-->
<!--        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path d="M10.3333 5.33332H6.66668V1.66662C6.66668 1.2987 6.36798 1 5.99994 1C5.63202 1 5.33332 1.2987 5.33332 1.66662V5.33332H1.66662C1.2987 5.33332 1 5.63202 1 5.99994C1 6.36798 1.2987 6.66668 1.66662 6.66668H5.33332V10.3333C5.33332 10.7013 5.63202 11 5.99994 11C6.36798 11 6.66668 10.7013 6.66668 10.3333V6.66668H10.3333C10.7013 6.66668 11 6.36798 11 5.99994C11 5.63202 10.7013 5.33332 10.3333 5.33332Z" fill="white"/>-->
<!--        </svg>-->
<!--        Attach files-->
<!--      </button>-->
<!--    </div>-->
    <div class="navigation-files-block" :class="{'small-svg': visibleAddFile && !normalSizeButton}">
      <p :class="{'fw500 fz18 text-dark': !visibleAddFile && !classForTitle, 'fz13 text-gray': visibleAddFile && !classForTitle, classForTitle}">
        <svg v-on:click="closeFolder" v-if="nameFolder !== (visibleAddFile? 'Attachments' : 'Files')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.25 11.2003H6.28787L11.5 6.37938C11.8 6.07458 11.8116 5.56819 11.5259 5.24819C11.2405 4.9286 10.7657 4.9158 10.4654 5.22059L4.4395 10.8687C4.15637 11.1711 4 11.5727 4 12.0003C4 12.4275 4.15637 12.8295 4.45262 13.1451L10.4654 18.6584C10.6105 18.806 10.7965 18.8792 10.9825 18.8792C11.1805 18.8792 11.3785 18.796 11.5259 18.6308C11.8116 18.3108 11.8 17.8048 11.5 17.5L6.26425 12.8003H19.25C19.664 12.8003 20 12.4419 20 12.0003C20 11.5587 19.664 11.2003 19.25 11.2003Z" fill="#2C2C2C"/>
        </svg>
        {{nameFolder}}
      </p>
      <button class="download-all" v-tooltip="'Download all files'" :class="{'load-button': disabledDownloadAll}" :disabled="disabledDownloadAll" v-on:click="downloadAll">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.034 5C13.034 4.6134 12.7206 4.3 12.334 4.3C11.9474 4.3 11.634 4.6134 11.634 5H13.034ZM12.334 14L11.8399 14.4959C12.113 14.768 12.5549 14.768 12.828 14.4959L12.334 14ZM16.828 10.5102C17.1019 10.2373 17.1027 9.79412 16.8298 9.52026C16.5569 9.2464 16.1137 9.24561 15.8399 9.51848L16.828 10.5102ZM8.82804 9.51848C8.55419 9.24561 8.11097 9.2464 7.8381 9.52026C7.56522 9.79412 7.56602 10.2373 7.83987 10.5102L8.82804 9.51848ZM19.7006 16C19.7006 15.6134 19.3872 15.3 19.0006 15.3C18.614 15.3 18.3006 15.6134 18.3006 16H19.7006ZM6.03397 16C6.03397 15.6134 5.72057 15.3 5.33397 15.3C4.94737 15.3 4.63397 15.6134 4.63397 16H6.03397ZM11.634 5V14H13.034V5H11.634ZM12.828 14.4959L16.828 10.5102L15.8399 9.51848L11.8399 13.5041L12.828 14.4959ZM12.828 13.5041L8.82804 9.51848L7.83987 10.5102L11.8399 14.4959L12.828 13.5041ZM17.0006 18.3H7.33397V19.7H17.0006V18.3ZM18.3006 16V17H19.7006V16H18.3006ZM6.03397 17V16H4.63397V17H6.03397ZM7.33397 18.3C6.616 18.3 6.03397 17.718 6.03397 17H4.63397C4.63397 18.4912 5.84281 19.7 7.33397 19.7V18.3ZM17.0006 19.7C18.4918 19.7 19.7006 18.4912 19.7006 17H18.3006C18.3006 17.718 17.7186 18.3 17.0006 18.3V19.7Z" fill="#2C2C2C"/>
        </svg>
      </button>
      <button class="button-create-folder" v-tooltip="'Create new folder'" :class="{'load-button': disabledAddNewFolder}" :disabled="disabledAddNewFolder" v-on:click="addNewFolder" v-if="addFilePermission">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.00195 7.00081V5.39668C4.00105 4.63098 4.63113 4.00769 5.41372 4.00009H10.642C10.7023 3.99825 10.7602 4.02373 10.7988 4.06916L12.0929 6.57471H18.5902C19.3721 6.5823 20.002 7.20467 20.002 7.96976V16.6049C20.002 17.37 19.3721 17.9924 18.5902 18H14.002" stroke="#2C2C2C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.2241 13.2222H7.77975V9.77773C7.77975 9.34849 7.43126 9 7.00188 9C6.57264 9 6.22415 9.34849 6.22415 9.77773V13.2222H2.77968C2.35044 13.2222 2.00195 13.5707 2.00195 13.9999C2.00195 14.4293 2.35044 14.7778 2.77968 14.7778H6.22415V18.2221C6.22415 18.6515 6.57264 19 7.00188 19C7.43126 19 7.77975 18.6515 7.77975 18.2221V14.7778H11.2241C11.6535 14.7778 12.002 14.4293 12.002 13.9999C12.002 13.5707 11.6535 13.2222 11.2241 13.2222Z" fill="#2C2C2C"/>
        </svg>
      </button>
      <button class="upload-file" v-tooltip="'Add new file'" v-if="visibleAddFile && addFilePermission">
        <input type="file" multiple  id="files" ref="files" v-on:change="handleFilesUpload">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29999 6C5.29999 4.50883 6.50882 3.3 7.99999 3.3H13.6418L19.7 9.52821V17C19.7 18.4912 18.4912 19.7 17 19.7H15.5C15.1134 19.7 14.8 19.3866 14.8 19C14.8 18.6134 15.1134 18.3 15.5 18.3H17C17.718 18.3 18.3 17.718 18.3 17V10.5125H14.3461C13.4073 10.5125 12.6461 9.75139 12.6461 8.8125V4.7H7.99999C7.28202 4.7 6.69999 5.28203 6.69999 6V9C6.69999 9.3866 6.38659 9.7 5.99999 9.7C5.61339 9.7 5.29999 9.3866 5.29999 9V6ZM14.0461 5.72358L17.3426 9.1125H14.3461C14.1805 9.1125 14.0461 8.97819 14.0461 8.8125V5.72358Z" fill="#2C2C2C"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99999 11.3C9.38659 11.3 9.69999 11.6134 9.69999 12V15.3H13C13.3866 15.3 13.7 15.6134 13.7 16C13.7 16.3866 13.3866 16.7 13 16.7H9.69999V20C9.69999 20.3866 9.38659 20.7 8.99999 20.7C8.61339 20.7 8.29999 20.3866 8.29999 20V16.7H4.99999C4.61339 16.7 4.29999 16.3866 4.29999 16C4.29999 15.6134 4.61339 15.3 4.99999 15.3H8.29999V12C8.29999 11.6134 8.61339 11.3 8.99999 11.3Z" fill="#2C2C2C"/>
        </svg>
      </button>
    </div>
<!--    {{localFiles}}-->
    <div class="files-block" :key="'34sd'+keyRender" v-if="localFiles !== null">
      <transition name="fade">
        <app-loader class="loader-file" :class="{'bgc-gray': bgcGray}" v-if="isLoader"></app-loader>
      </transition>
      <div v-for="(f, a) in localFiles" :key="'23s'+a">
        <div class="file-type" v-if="f.file_type === 'FILE' || f.file_type === undefined">
          <img v-on:click="showViewFileModal(a)" :src="getUrlPreviewFile(f)" class="img-preview" alt="preview" v-if="getUrlPreviewFile(f) !== null && !getTypeVideo(f.name)">
          <img v-on:click="showViewFileModal(a)" src="../../assets/imgNone.svg" v-if="getUrlPreviewFile(f) === null || getTypeVideo(f.name)">
<!--          <svg v-on:click="showViewFileModal(a)" v-if="getTypeDoc(f.name)" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="counterparties-add_block_attachment-img"><path d="M6.83985 48H41.1598C42.8167 48 44.1598 46.6569 44.1598 45V13.44L30.7198 0H6.83984C5.18299 0 3.83984 1.34315 3.83984 3V45C3.83984 46.6569 5.18299 48 6.83985 48Z" fill="#DEE3EA"></path><path d="M44.1602 13.4414L33.7202 13.4414C32.0633 13.4414 30.7202 12.0983 30.7202 10.4414L30.7202 0.00140549L36.8002 6.18381L44.1602 13.4414Z" fill="#BDCBD6"></path><path d="M12.0527 22.7051H15.0352C16.293 22.7051 17.2734 23.0742 17.9766 23.8125C18.6836 24.5508 19.0371 25.5859 19.0371 26.918C19.0371 28.2539 18.6855 29.2949 17.9824 30.041C17.2793 30.7871 16.2969 31.1602 15.0352 31.1602H12.0527V22.7051ZM13.3652 23.8359V30.0234H14.9121C15.8105 30.0234 16.498 29.7578 16.9746 29.2266C17.4551 28.6953 17.6953 27.9297 17.6953 26.9297C17.6953 25.9336 17.4551 25.1699 16.9746 24.6387C16.4941 24.1035 15.8066 23.8359 14.9121 23.8359H13.3652ZM23.9473 22.5645C25.1621 22.5645 26.125 22.957 26.8359 23.7422C27.5508 24.5273 27.9082 25.5918 27.9082 26.9355C27.9082 28.2793 27.5527 29.3438 26.8418 30.1289C26.1309 30.9102 25.166 31.3008 23.9473 31.3008C22.7285 31.3008 21.7637 30.9102 21.0527 30.1289C20.3418 29.3438 19.9863 28.2793 19.9863 26.9355C19.9863 25.5918 20.3418 24.5273 21.0527 23.7422C21.7637 22.957 22.7285 22.5645 23.9473 22.5645ZM23.9473 23.7188C23.1426 23.7188 22.5039 24.0078 22.0312 24.5859C21.5625 25.1641 21.3281 25.9473 21.3281 26.9355C21.3281 27.9199 21.5625 28.7012 22.0312 29.2793C22.5039 29.8574 23.1426 30.1465 23.9473 30.1465C24.748 30.1465 25.3828 29.8574 25.8516 29.2793C26.3242 28.7012 26.5605 27.9199 26.5605 26.9355C26.5605 25.9473 26.3242 25.1641 25.8516 24.5859C25.3828 24.0078 24.748 23.7188 23.9473 23.7188ZM32.7305 31.3008C31.543 31.3008 30.5996 30.9082 29.9004 30.123C29.2051 29.3379 28.8574 28.2734 28.8574 26.9297C28.8574 25.5938 29.207 24.5332 29.9062 23.748C30.6055 22.959 31.5469 22.5645 32.7305 22.5645C33.6914 22.5645 34.502 22.8359 35.1621 23.3789C35.8223 23.918 36.207 24.627 36.3164 25.5059H35.0156C34.8984 24.9629 34.6309 24.5293 34.2129 24.2051C33.7988 23.877 33.3047 23.7129 32.7305 23.7129C31.9609 23.7129 31.3457 24.0059 30.8848 24.5918C30.4277 25.1738 30.1992 25.9531 30.1992 26.9297C30.1992 27.918 30.4277 28.7031 30.8848 29.2852C31.3418 29.8633 31.959 30.1523 32.7363 30.1523C33.3223 30.1523 33.8145 30.0098 34.2129 29.7246C34.6152 29.4395 34.8828 29.041 35.0156 28.5293H36.3223C36.1621 29.4043 35.7656 30.0859 35.1328 30.5742C34.5039 31.0586 33.7031 31.3008 32.7305 31.3008Z" fill="#094172"></path></svg>-->
          <p :contenteditable="f.editMode && editPermission !== false" :id="'editText'+f.id" v-if="getPermissionsForUserDeleteOrRenameFile" v-on:keyup.enter="changeNameFile(f)" v-on:dblclick="editModeFile(f)" @focusout="editmodeFalse(f)" @input="inputEditFile" :class="{'editMode':f.editMode}" class="fz11 text-dark">{{f.name}}</p>
          <p :class="{'editMode':f.editMode}" class="fz11 text-dark" v-if="!getPermissionsForUserDeleteOrRenameFile">{{f.name}}</p>
          <p class="fz10 text-gray">{{f.size}}</p>
          <task-full-info-file-option-button :perm-edit="editPermission !== false" :perm-delete="getPermissionDeleteFile() !== false" @emitDeleteFile="deleteFile(f)" :file="f" @emitEditMode="editModeFile(f, true)" class="option-button"></task-full-info-file-option-button>
        </div>
        <div class="file-type" v-if="f.file_type === 'FOLDER'">
          <img src="../../assets/folder.svg" v-on:click="openFolder(a)">
          <p :contenteditable="f.editMode && editPermission !== false" :id="'editText'+f.id" v-if="getPermissionsForUserDeleteOrRenameFile" v-on:keyup.enter="changeNameFile(f)" v-on:dblclick="editModeFile(f)" @focusout="editmodeFalse(f)" @input="inputEditFile" :class="{'editMode':f.editMode}" class="fz11 text-dark">{{f.name}}</p>
          <p :class="{'editMode':f.editMode}" class="fz11 text-dark" v-if="!getPermissionsForUserDeleteOrRenameFile">{{f.name}}</p>
          <task-full-info-file-option-button :perm-edit="editPermission !== false" :perm-delete="getPermissionDeleteFile() !== false" @emitDeleteFile="deleteFile(f)" :file="f" @emitEditMode="editModeFile(f, true)" class="option-button"></task-full-info-file-option-button>
        </div>
      </div>
<!--{{routerIdFolder}}-->
    </div>
    <transition name="fade">
      <div class="view-file" v-show="showViewFile">
        <div class="container">
          <div class="view-file__top-panel">
            <div class="edit-file-name">
              <button class="edit-file-name__button fz14 fw500" v-on:click="editNameInModal" v-if="!editNameModeInModal">
                {{editNameFileInModal}}
                <svg v-if="editPermission !== false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.9815 6.02666C17.3235 5.36566 16.4509 5 15.5175 5C14.5889 5 13.7116 5.36566 13.0536 6.02666L5.84634 13.276C5.74367 13.3791 5.68301 13.5104 5.65967 13.651L5.00635 18.2499C4.97835 18.4515 5.04368 18.6578 5.18835 18.8031C5.30968 18.9297 5.48234 19 5.65501 19C5.68301 19 5.70634 19 5.73434 18.9953L10.387 18.414C10.5316 18.3953 10.667 18.3296 10.7696 18.2265L17.9815 10.9725C19.3395 9.60357 19.3395 7.39086 17.9815 6.02666ZM10.0043 17.1342L6.42033 17.5795L6.92433 14.0495L12.8016 8.13624L15.8769 11.2256L10.0043 17.1342ZM17.0622 10.0489L16.8055 10.3068L13.7302 7.2174L13.9869 6.95957C14.3929 6.53765 14.9389 6.31263 15.5222 6.31263C16.1009 6.31263 16.6515 6.53765 17.0622 6.95488C17.4728 7.37211 17.7015 7.91591 17.7015 8.5019C17.7015 9.08321 17.4775 9.63639 17.0622 10.0489Z" fill="white"/>
                </svg>
              </button>
              <div class="edit-file-name__block" v-if="editNameModeInModal && editPermission !== false">
                <input type="text" class="fz14 fw500 text-white" v-model="editNameFileInModal">
                <button v-on:click="saveEditNameInModal">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.9783 6.2675C17.6651 5.91943 17.1483 5.90978 16.8239 6.24594C16.8172 6.25297 16.8105 6.26016 16.8039 6.2675L10.535 14.8915L7.38355 12.2611C7.05922 11.9249 6.54241 11.9345 6.22918 12.2826C5.92361 12.6222 5.92361 13.1604 6.22918 13.5L9.95778 16.7499C10.2766 17.092 10.7934 17.092 11.1121 16.7499L17.9582 7.50645C18.2826 7.17023 18.2915 6.61558 17.9783 6.2675Z" fill="white"/>
                  </svg>
                </button>
                <button v-on:click="closeEditNameInModal">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.51424 7.57874C6.21661 7.28404 6.21661 6.80625 6.51424 6.51155C6.81186 6.21685 7.29441 6.21685 7.59204 6.51155L17.4868 16.2975C17.7844 16.5922 17.7844 17.07 17.4868 17.3647C17.1892 17.6594 16.7066 17.6594 16.409 17.3647L6.51424 7.57874Z" fill="white"/>
                    <path d="M16.4091 6.63547C16.7067 6.34077 17.1893 6.34077 17.4869 6.63547C17.7845 6.93016 17.7845 7.40796 17.4869 7.70266L7.59214 17.4886C7.29451 17.7833 6.81196 17.7833 6.51434 17.4886C6.21671 17.1939 6.21671 16.7161 6.51434 16.4214L16.4091 6.63547Z" fill="white"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="block-scale-button">
              <div class="block-scale-button__block">
                <button v-on:click="zoomOut">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.2222 12.7778L5.77787 12.7778C5.34849 12.7778 5 12.4293 5 12.0001C5 11.5707 5.34849 11.2222 5.77787 11.2222L11.2222 11.2222L12.7778 11.2222L18.2223 11.2222C18.6515 11.2222 19 11.5707 19 12.0001C19 12.4293 18.6515 12.7778 18.2223 12.7778L12.7778 12.7778L11.2222 12.7778Z" fill="white"/>
                  </svg>
                </button>
                <p class="fz13 fw500 text-white-always">{{ zoomFile }}%</p>
                <button v-on:click="zoomIn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.7778 18.2221L12.7778 12.7778L18.2223 12.7778C18.6515 12.7778 19 12.4293 19 11.9999C19 11.5707 18.6515 11.2222 18.2223 11.2222L12.7778 11.2222L12.7778 5.77773C12.7778 5.34849 12.4293 5 12.0001 5C11.5707 5 11.2222 5.34849 11.2222 5.77773L11.2222 11.2222L5.77787 11.2222C5.34849 11.2222 5 11.5707 5 11.9999C5 12.4293 5.34849 12.7778 5.77787 12.7778L11.2222 12.7778L11.2222 18.2221C11.2222 18.6515 11.5707 19 12.0001 19C12.4293 19 12.7778 18.6515 12.7778 18.2221Z" fill="white"/>
                  </svg>
                </button>
              </div>
              <button v-on:click="zoomSetDefault">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.77951 5.77792L5.77951 5.07788C5.39293 5.07788 5.07955 5.3913 5.07955 5.77792L5.77951 5.77792ZM18.2224 18.2221L18.2249 18.9222C18.6095 18.9208 18.921 18.6093 18.9224 18.2247L18.2224 18.2221ZM18.9351 14.6819C18.9365 14.2953 18.6243 13.9808 18.2377 13.9794C17.8511 13.978 17.5366 14.2903 17.5352 14.6769L18.9351 14.6819ZM14.6775 17.5349C14.2909 17.5363 13.9787 17.8508 13.9801 18.2374C13.9815 18.624 14.296 18.9363 14.6826 18.9349L14.6775 17.5349ZM9.33462 6.47795C9.7212 6.47795 10.0346 6.16454 10.0346 5.77792C10.0346 5.3913 9.7212 5.07788 9.33462 5.07788L9.33462 6.47795ZM5.07955 9.33341C5.07955 9.72003 5.39293 10.0334 5.77951 10.0334C6.16609 10.0334 6.47947 9.72003 6.47947 9.33341L5.07955 9.33341ZM5.28456 6.27292L17.7275 18.7171L18.7174 17.7271L6.27446 5.28292L5.28456 6.27292ZM18.9224 18.2247L18.9351 14.6819L17.5352 14.6769L17.5225 18.2196L18.9224 18.2247ZM18.2199 17.5221L14.6775 17.5349L14.6826 18.9349L18.2249 18.9222L18.2199 17.5221ZM5.77951 6.47795L9.33462 6.47795L9.33462 5.07788L5.77951 5.07788L5.77951 6.47795ZM5.07955 5.77792L5.07955 9.33341L6.47947 9.33341L6.47947 5.77792L5.07955 5.77792Z" fill="white"/>
                  <path d="M18.2209 5.77824L18.9209 5.77824C18.9209 5.39162 18.6075 5.0782 18.2209 5.0782L18.2209 5.77824ZM5.77802 18.2225L5.07806 18.225C5.07944 18.6096 5.39089 18.9211 5.7755 18.9225L5.77802 18.2225ZM9.31786 18.9352C9.70444 18.9366 10.0189 18.6244 10.0203 18.2377C10.0217 17.8511 9.70948 17.5366 9.3229 17.5352L9.31786 18.9352ZM6.46522 14.6772C6.46383 14.2906 6.14932 13.9783 5.76274 13.9797C5.37617 13.9811 5.06392 14.2956 5.06531 14.6822L6.46522 14.6772ZM17.521 9.33373C17.521 9.72035 17.8343 10.0338 18.2209 10.0338C18.6075 10.0338 18.9209 9.72035 18.9209 9.33373L17.521 9.33373ZM14.6658 5.0782C14.2792 5.0782 13.9658 5.39162 13.9658 5.77824C13.9658 6.16486 14.2792 6.47827 14.6658 6.47827L14.6658 5.0782ZM17.726 5.28323L5.28307 17.7275L6.27296 18.7175L18.7159 6.27324L17.726 5.28323ZM5.7755 18.9225L9.31786 18.9352L9.3229 17.5352L5.78054 17.5224L5.7755 18.9225ZM6.47797 18.2199L6.46522 14.6772L5.06531 14.6822L5.07806 18.225L6.47797 18.2199ZM17.521 5.77824L17.521 9.33373L18.9209 9.33373L18.9209 5.77824L17.521 5.77824ZM18.2209 5.0782L14.6658 5.0782L14.6658 6.47827L18.2209 6.47827L18.2209 5.0782Z" fill="white"/>
                </svg>
              </button>
            </div>
            <div class="block-option-button">
              <button class="block-option-button__download" v-on:click="downloadFile">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.034 5C13.034 4.6134 12.7206 4.3 12.334 4.3C11.9474 4.3 11.634 4.6134 11.634 5H13.034ZM12.334 14L11.8399 14.4959C12.113 14.768 12.5549 14.768 12.828 14.4959L12.334 14ZM16.828 10.5102C17.1019 10.2373 17.1027 9.79412 16.8298 9.52026C16.5569 9.2464 16.1137 9.24561 15.8399 9.51848L16.828 10.5102ZM8.82804 9.51848C8.55419 9.24561 8.11097 9.2464 7.8381 9.52026C7.56522 9.79412 7.56602 10.2373 7.83987 10.5102L8.82804 9.51848ZM19.7006 16C19.7006 15.6134 19.3872 15.3 19.0006 15.3C18.614 15.3 18.3006 15.6134 18.3006 16H19.7006ZM6.03397 16C6.03397 15.6134 5.72057 15.3 5.33397 15.3C4.94737 15.3 4.63397 15.6134 4.63397 16H6.03397ZM11.634 5V14H13.034V5H11.634ZM12.828 14.4959L16.828 10.5102L15.8399 9.51848L11.8399 13.5041L12.828 14.4959ZM12.828 13.5041L8.82804 9.51848L7.83987 10.5102L11.8399 14.4959L12.828 13.5041ZM17.0006 18.3H7.33397V19.7H17.0006V18.3ZM18.3006 16V17H19.7006V16H18.3006ZM6.03397 17V16H4.63397V17H6.03397ZM7.33397 18.3C6.616 18.3 6.03397 17.718 6.03397 17H4.63397C4.63397 18.4912 5.84281 19.7 7.33397 19.7V18.3ZM17.0006 19.7C18.4918 19.7 19.7006 18.4912 19.7006 17H18.3006C18.3006 17.718 17.7186 18.3 17.0006 18.3V19.7Z" fill="white"/>
                </svg>
              </button>
              <button class="block-option-button__delete" v-on:click="deleteFileInModal" v-if="getPermissionDeleteFile() !== false">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="white"/>
                </svg>
              </button>
              <button class="block-option-button__close" v-on:click="hideViewFileModal">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.51424 7.57874C6.21661 7.28404 6.21661 6.80625 6.51424 6.51155C6.81186 6.21685 7.29441 6.21685 7.59204 6.51155L17.4868 16.2975C17.7844 16.5922 17.7844 17.07 17.4868 17.3647C17.1892 17.6594 16.7066 17.6594 16.409 17.3647L6.51424 7.57874Z" fill="white"/>
                  <path d="M16.4091 6.63547C16.7067 6.34077 17.1893 6.34077 17.4869 6.63547C17.7845 6.93016 17.7845 7.40796 17.4869 7.70266L7.59214 17.4886C7.29451 17.7833 6.81196 17.7833 6.51434 17.4886C6.21671 17.1939 6.21671 16.7161 6.51434 16.4214L16.4091 6.63547Z" fill="white"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="view-file__main">
            <button class="button-prev" v-on:click="prevFile">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.71834 11.5972L14.8343 2.29486C15.1014 2.023 15.5339 2.02345 15.8006 2.29626C16.067 2.56904 16.0664 3.01092 15.7992 3.28299L7.16851 12.0911L15.7992 20.8084C16.0663 21.0805 16.067 21.5221 15.8006 21.7949C15.6669 21.9317 15.4918 22.0001 15.3166 22.0001C15.142 22.0001 14.9675 21.9321 14.8341 21.7963L5.71834 12.5851C5.58968 12.4544 5.51749 12.2765 5.51749 12.0911C5.51749 11.9058 5.58989 11.7281 5.71834 11.5972Z" fill="white"/>
              </svg>
            </button>
            <div class="block-with-file">
              <app-loader :is-local="true" v-if="isLoadIframe"></app-loader>
              <img v-if="formatThisImg" :src="viewFileSrc" alt="" :style="{transform: 'scale(' + zoomFile/100 + ')'}">
              <video v-if="formatThisVideo" controls="controls" :style="{transform: 'scale(' + zoomFile/100 + ')'}" :src="viewFileSrc"></video>
<!--              :src="getlinkPDF(viewFileSrc)"-->
              <iframe ref="iframe" :class="{'formatTxt': formatTxt}" v-show="formatIframe"
                      style="width: 100%; height: 100%;">Ваш браузер не поддерживает фреймы</iframe>
              <p v-if="!formatThisImg && !formatThisVideo && !formatIframe" class="fz16 fw500 text-white">Unable to display "File name".<br>Download the file to view it on your device</p>
            </div>
            <button class="button-next" v-on:click="nextFile">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.2817 12.4028L9.16569 21.7051C8.89857 21.977 8.46609 21.9765 8.19942 21.7037C7.93295 21.431 7.93364 20.9891 8.2008 20.717L16.8315 11.9089L8.2008 3.1916C7.93368 2.91949 7.93299 2.47789 8.19942 2.20508C8.3331 2.06832 8.50823 1.99994 8.68336 1.99994C8.85805 1.99994 9.03249 2.06786 9.16593 2.20367L18.2817 11.4149C18.4103 11.5456 18.4825 11.7235 18.4825 11.9089C18.4825 12.0942 18.4101 12.2719 18.2817 12.4028Z" fill="white"/>
              </svg>
            </button>
          </div>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
import TaskFullInfoFileOptionButton from "@/components/taks-full-info/task-full-info-file-option-button";
import {mapActions, mapGetters, mapMutations} from "vuex";
import axios from "axios";
import AppLoader from "@/components/loader";
import JSZip from "jszip";
export default {
name: "paymentDetailAtachementsFile",
  components: {AppLoader, TaskFullInfoFileOptionButton},
  computed: mapGetters(["getPermissionsByType", "getPermissionsForUserCanAddFile", "getPermissionsForUserDeleteOrRenameFile"]),
  props: {
    disabledAddNewFolder: {
      type: Boolean,
      default: false,
    },
    fileProps: {
      type: Array,
    },
    classForTitle: {
      type: String,
      default: "",
    },
    visibleAddFile: {
      type: Boolean,
      default: false,
    },
    awaitDeleteFile: {
      type: Boolean,
      default: false,
    },
    deleteFilePermission: null,
    editPermission: null,
    addFilePermission: {
      type: Boolean,
      default: true
    },
    normalSizeButton: {
      type: Boolean,
      default: false,
    },
    bgcGray: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      formatIMG: [".jpeg", ".png", ".raw", ".jpg", ".bmp", ".gif", ".svg"],
      formatVIDEO: [".mkv", ".mov"],
      formatIFRAME: [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".xps", ".ppt", ".pptx", ".ps", ".eps", '.txt'],
      zoomFile: 100,
      showViewFile: false,
      formatTxt: false,
      viewFileSrc: "",
      files: [],
      editNameFile: "",
      fileNameCopy: "",
      keyRender: -1000,
      keyRenderIFRAME: -5000,
      editNameModeInModal: false,
      editNameFileInModal: "",
      formatThisImg: false,
      formatThisVideo: false,
      formatIframe: false,
      showViewFileIndex: null,
      nameFolder: 'Files',
      routerIdFolder: [],
      localFiles: [],
      isLoader: false,
      disabledDownloadAll: false,
      isLoadIframe: false,
    }
  },
  watch: {
    fileProps() {
      if(this.routerIdFolder.length === 0) {
        // for(let i=0; i<this.fileProps.length; i++) {
        //   this.fileProps[i].editMode = false;
        //   this.fileProps[i].file = this.getUrlPreviewFile(this.fileProps[i])
        //   this.fileProps[i].thumbnail = this.getUrlPreviewFile(this.fileProps[i])
        // }
        this.localFiles = JSON.parse(JSON.stringify(this.fileProps));
        for(let i=0; i<this.localFiles.length; i++) {
          this.localFiles[i].editMode = false;
          this.localFiles[i].file = this.localFiles[i].file ? this.getUrlForFile(''+this.localFiles[i].file) : null
          this.localFiles[i].thumbnail = this.getUrlPreviewFile(this.localFiles[i])
        }
      }
      this.openFolderToRouter()
    },
  },
  methods: {
  ...mapActions(["axiosDownloadFolder", "getFileInFolder", "axiosFileChangeName", "axiosFileDelete"]),
    ...mapMutations(["addTip"]),
    async checkCorrectNameFiles() {
      function countMatchingElements(arr, searchTerm) {
        return arr.filter(function(item) { return item === searchTerm; }).length;
      }
      let names = this.localFiles.map(a=> {
          return a.name
      }).filter(a=> a !== null)
      this.localFiles.reverse().forEach((item) => {
        let count = countMatchingElements(names, item.name)
        if(count > 1) {
          names.splice(names.indexOf(item.name), 1)
          let name = item.name.lastIndexOf(".") !== -1 ? item.name.slice(0, item.name.lastIndexOf(".")) + '_' + (count - 1) + '' + item.name.substring(item.name.lastIndexOf(".")) : item.name + '_' + (count - 1) + ''
          if(names.indexOf(name) >= 0) {
            let countName = 1;
            while(names.indexOf(name) >= 0) {
              name = item.name.lastIndexOf(".") !== -1 ? item.name.slice(0, item.name.lastIndexOf(".")) + '_' + (countName) + '' + item.name.substring(item.name.lastIndexOf(".")) : item.name + '_' + (countName) + '';
              countName++;
            }
          }
          names.push(name)
          this.editNameFile = name;
          this.changeNameFile(item, true)
        }
      })
    },
    getCheckName(nameCurrent, nameOld) {
      function countMatchingElements(arr, searchTerm) {
        return Array.isArray(arr) === true ? arr.filter(function(item) { return item === searchTerm; }).length : 0;
      }
      let names = this.localFiles.map(a=> {
          return a.name
      }).filter(a=> a !== null && a !== nameOld)
      names.push(nameCurrent)
      let count = countMatchingElements(names, nameCurrent)
      if(count > 1) {
        let name = nameCurrent.indexOf('.') !== -1 ? nameCurrent.slice(0, nameCurrent.lastIndexOf(".")) + ' (' + (count - 1) + ')' + nameCurrent.substring(nameCurrent.lastIndexOf(".")) : nameCurrent + ' (' + (count - 1) + ')'
        names.splice(names.indexOf(nameCurrent), 1)
          if(names.indexOf(name) >= 0) {
            let countName = 1;
            while(names.indexOf(name) >= 0) {
              name = nameCurrent.indexOf('.') !== -1 ? nameCurrent.slice(0, nameCurrent.lastIndexOf(".")) + ' (' + (countName) + ')' + nameCurrent.substring(nameCurrent.lastIndexOf(".")) : nameCurrent + ' (' + (countName) + ')';
              countName++;
            }
          }
        return name
        }
      return nameCurrent
    },
    getUrlPreviewFile(file) {
      if(file.thumbnail !== null && (''+file.thumbnail).length !== 0) {
        return this.getUrlForFile(file.thumbnail)
      } else if(file.file) {
        let type = file.name.substring(file.name.lastIndexOf("."));
        if(this.formatIMG.indexOf(type)>=0 || this.formatVIDEO.indexOf(type) >=0) {
          return this.getUrlForFile(file.file)
        }
      }
      return null
    },
    getTypeVideo(name) {
      let type = name.substring(name.lastIndexOf("."));
      if(this.formatVIDEO.indexOf(type) >=0) {
        return true
      }
      return false
    },
    getTypeDoc(name) {
      let type = name.substring(name.lastIndexOf("."));
      if(this.formatIFRAME.indexOf(type) >=0 && '.txt'.indexOf(type) === -1) {
        return true
      }
      return false
    },
    getUrlForFile(link) {
      if((''+link).indexOf(this.getURL()) >= 0) {
        return link;
      }
      if((''+link).indexOf('/media/') >= 0) {
        return this.getURL() + link;
      }
      if((''+link).indexOf('media/') >= 0) {
        return this.getURL() +"/" + link;
      }
      return this.getURL() +"/media/" + link;
    },
    getURL() {
      return process.env.VUE_APP_URL_SIMPLE
    },
    async downloadAll() {
      let id = [];
      this.localFiles.map(a=> {
        id.push(a.id)
      })
      this.disabledDownloadAll = true;
      let response = await this.axiosDownloadFolder(id);
      if(response !== null) {
        JSZip.loadAsync(response.data).then(res=> {
          res.generateAsync({type: "blob"})
              .then((content) => {
                let link1 = document.createElement("a");
                link1.href = window.URL.createObjectURL(content);
                link1.download = this.nameFolder;
                link1.click();
                this.disabledDownloadAll = false;

              }).catch(()=> {
            this.disabledDownloadAll = false;
          });
        }).catch( ()=> {
          this.disabledDownloadAll = false;
        })
      } else {
        this.disabledDownloadAll = false;
        this.addTip("There are no files to download")
      }
      // let content = JSZip.folder(response.data, 'zip')

    },
    openFolder(index) {
      this.nameFolder = this.localFiles[index].name
      this.routerIdFolder.push(this.localFiles[index].id)
      // let id = this.localFiles[index].id;
      // this.localFiles = this.localFiles[index].child_objects;
      this.openFolderToRouter()
      // this.$emit("changeParentId", id)
    },
    closeFolder() {
      if(this.routerIdFolder.length !== 0) {
        this.routerIdFolder.splice(-1, 1);
        // console.log(this.routerIdFolder)
        this.openFolderToRouter();
      }
    },
    async openFolderToRouter() {
      if(this.routerIdFolder.length !== 0) {
        let error = 0;
        this.localFiles = [];
        this.isLoader = true;
        let files = await this.getFileInFolder(this.routerIdFolder[this.routerIdFolder.length-1]);
        if(files === null) {
          error++;
        }
        this.isLoader = false;
        // this.routerIdFolder.map(a=> {
        //   files=files.filter(b=> b.id === a)
        //   if(files.length !== 0) {
        //     files = files[0].child_objects;
        //   } else {
        //     error++;
        //   }
        // })

        if(error === 0) {
          console.log(1)
          this.localFiles = files.child_objects
          this.$emit("changeParentId", this.routerIdFolder[this.routerIdFolder.length-1])
        } else {
          this.routerIdFolder = [];
          this.localFiles = JSON.parse(JSON.stringify(this.fileProps));
          for(let i=0; i<this.localFiles.length; i++) {
            this.localFiles[i].editMode = false;
            this.localFiles[i].file = this.getUrlForFile(this.localFiles[i].file)
            this.localFiles[i].thumbnail = this.getUrlPreviewFile(this.localFiles[i])
          }
          this.nameFolder = this.visibleAddFile? 'Attachments' : 'Files'
          this.$emit("changeParentId", null)
        }
        await this.checkCorrectNameFiles();
      } else {
        this.localFiles = JSON.parse(JSON.stringify(this.fileProps));
        for(let i=0; i<this.localFiles.length; i++) {
          this.localFiles[i].editMode = false;
          this.localFiles[i].file = this.getUrlForFile(this.localFiles[i].file)
          this.localFiles[i].thumbnail = this.getUrlPreviewFile(this.localFiles[i])
        }
        this.nameFolder = this.visibleAddFile? 'Attachments' : 'Files'
        await this.checkCorrectNameFiles();
        this.$emit("changeParentId", null)
      }

    },
    addNewFolder() {
      let parts = [
        new Blob([''], {type: 'text/plain'}),
        '',
        new Uint16Array([33])
      ];
    let file = new File(parts, "New Folder")
      file.file_type = "FOLDER";
      if(this.routerIdFolder.length !== 0) {
        file.parent_id = this.routerIdFolder[this.routerIdFolder.length-1];
        file['parent_file'] = this.routerIdFolder[this.routerIdFolder.length-1];
      }
      let array = [];
      array.push(file)
      // console.log(file)
      this.$emit("addFile", array)
    },
    getPermissionDeleteFile() {
      return this.deleteFilePermission;
    },
    getlinkPDF(link) {
      // if(link.substring(link.lastIndexOf(".")).indexOf('txt') >=0) {
      //   this.formatTxt = true;
      //   return link
      // } else {
      //   this.formatTxt = false;
      // }
      // alert(this.formatIframe ? "http://docs.google.com/gview?url="+link +"&embedded=true" : '')

      return "https://docs.google.com/gview?url="+link +"&embedded=true"
    },
    prevFile() {
      if(this.showViewFileIndex !== 0) {
        let index = this.showViewFileIndex;
        index-=1;
        if(this.localFiles[index].file_type === 'FOLDER') {
          do {
            index -=1;
          } while(index > 0 && this.localFiles[index].file_type === 'FOLDER')
          if(this.localFiles[index].file_type !== 'FOLDER') {
            this.showViewFileIndex = index;
            this.zoomFile = 100;
            this.showViewFileModal(this.showViewFileIndex);
          }
        } else {
          this.showViewFileIndex = index;
          this.zoomFile = 100;
          this.showViewFileModal(this.showViewFileIndex);
        }

      }
    },
    nextFile() {
      if(this.showViewFileIndex !== this.localFiles.length-1) {
        let index = this.showViewFileIndex;
        index++;
        if(this.localFiles[index].file_type === 'FOLDER') {
          do {
            index +=1;
          } while(index < this.localFiles.length-1 && this.localFiles[index].file_type === 'FOLDER')
          if(this.localFiles[index].file_type !== 'FOLDER') {
            this.showViewFileIndex = index;
            this.zoomFile = 100;
            this.showViewFileModal(this.showViewFileIndex);
          }
        } else {
          this.showViewFileIndex = index;
          this.zoomFile = 100;
          this.showViewFileModal(this.showViewFileIndex);
        }
      }
    },
    hideViewFileModal() {
      this.showViewFile = false;
      this.viewFileSrc = "";
      this.zoomFile = 100;
      this.showViewFileIndex = null;
    },
    deleteFileInModal() {
      // let textRoute = this.$route.path;
        // let idTask = textRoute.replace(/[^-0-9]/gim, '');
      // console.log(this.localFiles);
      this.$emit("emitBeforeDeleteFileFillFile", this.localFiles[this.showViewFileIndex])
      this.$emit("emitBeforeDeleteFile", this.localFiles[this.showViewFileIndex].id);

      if(this.awaitDeleteFile !== true) {
        this.showLoad();
        this.axiosFileDelete(this.localFiles[this.showViewFileIndex].id).then(() => {
          // console.log(this.localFiles)
          let index = -1;
          for(let i=0; i<this.localFiles.length; i++) {
            if(this.localFiles[this.showViewFileIndex].id === this.localFiles[i].id) {
              index = i;
            }
          }
          // console.log(index)
          if (index > -1) {
            this.localFiles.splice(index, 1);
          }
          // console.log(this.localFiles)

          if (this.showViewFileIndex < this.localFiles.length - 1) {
            this.showViewFileModal(this.showViewFileIndex);
          } else {
            this.showViewFileModal(this.localFiles.length - 1);
          }
          this.hideViewFileModal();
          this.hideLoad();
        });
      }
      this.hideViewFileModal();

      // else {
      //   this.deleteFileInModalAfterEmit();
      // }
    },
    deleteFileInModalAfterEmit() {
        // console.log(this.localFiles)
        let index = -1;
        for(let i=0; i<this.localFiles.length; i++) {
          if(this.localFiles[this.showViewFileIndex].id === this.localFiles[i].id) {
            index = i;
          }
        }
        // console.log(index)
        if (index > -1) {
          this.localFiles.splice(index, 1);
        }
        // console.log(this.localFiles)

        if (this.showViewFileIndex < this.localFiles.length - 1) {
          this.showViewFileModal(this.showViewFileIndex);
        } else {
          this.showViewFileModal(this.localFiles.length - 1);
        }
    },
    downloadFile() {
      let file = this.localFiles[this.showViewFileIndex];
      axios.get(file.file, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = file.name;
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)

      // axios({
      //   url: file.file, //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   console.log(url)
      //   link.href = url
      //   link.setAttribute('download', file.name);
      //   document.body.appendChild(link);
      //   link.click();
      // })
    },
    zoomSetDefault() {
      this.zoomFile = 100;
    },
    zoomOut() {
      if(this.zoomFile !== 10 && !this.formatThisVideo && !this.formatIframe) {
        this.zoomFile-=10
      }
    },
    zoomIn() {
      if(this.zoomFile !== 400 && !this.formatThisVideo && !this.formatIframe) {
        this.zoomFile+=10
      }
    },
    closeEditNameInModal() {
      this.editNameModeInModal = false;
      this.editNameFileInModal = JSON.parse(JSON.stringify(this.localFiles[this.showViewFileIndex].name));
    },
    saveEditNameInModal() {
      let file = this.localFiles[this.showViewFileIndex]
      this.editNameFileInModal = this.editNameFileInModal.replace(/\r?\n/g, "");
      let name = ""+this.editNameFileInModal;
      // this.axiosFileChangeName({id: file.id, name: this.editNameFile}).then(()=> {
      //   this.$emit('fileNameChanged');
      // });
      file.name = name;
      this.axiosFileChangeName({id: file.id, name: name}).then((response)=> {
        // console.log(response)
        if(response) {
          this.$emit('fileNameChanged');
        } else {
          file.name = JSON.parse(JSON.stringify(this.localFiles[this.showViewFileIndex].name));
        }
      });



      this.editNameModeInModal = false;
    },
    editNameInModal() {
      if(this.editPermission !== false) {
        this.editNameModeInModal = true;
      }
      // this.editNameFileInModal = JSON.parse(JSON.stringify(this.getFileForTask[this.showViewFileIndex].name));
    },
    handleFilesUpload(e){
      console.log(e)
      if(this.getPermissionsForUserCanAddFile) {
        this.files = e.target.files;
        // this.files = this.$refs.files.files;
        if(this.files.length !== 0) {
          if(this.routerIdFolder.length !== 0) {
            for(let i=0; i< this.files.length; i++) {
              this.files[i]["parent_id"] = this.routerIdFolder[this.routerIdFolder.length-1];

            }
          }
          this.$emit("addFile", this.files)
        }
      }
      e.target.value = ""
    },
    getUrlViewFileAndCheck() {
      if(this.showViewFileIndex >= this.localFiles.length) {
        this.showViewFileIndex = this.localFiles.length - 1
      }
      if(this.viewFileSrc !== this.localFiles[this.showViewFileIndex].file) {
        this.viewFileSrc = this.localFiles[this.showViewFileIndex].file;
      }
      return this.viewFileSrc;

    },
    showViewFileModal(index) {
    if(this.localFiles.length !== 0) {
      this.showViewFile = true;
      this.showViewFileIndex = index;
      this.viewFileSrc = this.localFiles[index].file;
      this.editNameFileInModal = JSON.parse(JSON.stringify(this.localFiles[this.showViewFileIndex].name));
      let type = this.editNameFileInModal.substring(this.editNameFileInModal.lastIndexOf("."));
      this.formatThisImg = false;
      this.formatThisVideo = false;
      this.formatIframe = false;
      // console.log("type")
      // console.log(this.editNameFileInModal.lastIndexOf("."));
      // console.log((this.editNameFileInModal.length -1))
      // console.log(type);
      if(this.formatIMG.indexOf(type.toLowerCase()) !== -1) {
        this.formatThisImg = true;
      } else if(this.formatVIDEO.indexOf(type.toLowerCase()) !== -1) {
        this.formatThisVideo = true;
      } else if(this.formatIFRAME.indexOf(type.toLowerCase()) !== -1){
        this.formatIframe = true;
        this.isLoadIframe = true;
        let iframe = this.$refs.iframe
        let vm = this;
        iframe.src=''
        iframe.src = this.getlinkPDF(this.viewFileSrc);
        console.log('iframe', iframe.src)

        if (navigator.userAgent.indexOf("MSIE") > -1 && !window.opera) {
          iframe.onreadystatechange = function(){
            if (iframe.readyState == "complete"){
              // alert("Iframe is now loaded.");
              vm.isLoadIframe = false;
            }
          };
        } else {
          iframe.onload = function(){
            // alert("Iframe is now loaded.");
            vm.isLoadIframe = false;
          };
        }
        setTimeout(()=> {
          this.isLoadIframe = false
        }, 2500)
      }
    } else {
      this.hideViewFileModal();
    }
    },
    changeNameFile(file, notCheck) {
      console.log(file);
      this.editNameFile = this.editNameFile.replace(/\r?\n/g, "");
      let name = ""+this.editNameFile;
      // this.axiosFileChangeName({id: file.id, name: this.editNameFile}).then(()=> {
      //   this.$emit('fileNameChanged');
      // });
      file.name = notCheck === true ? name : this.getCheckName(name, file.name);
      this.axiosFileChangeName({id: file.id, name: name}).then((response)=> {
        console.log(response)
        if(response) {
          this.$emit('fileNameChanged');
        } else {
          file.name = this.fileNameCopy;
        }
      });
    },
    deleteFile(file) {
    this.$emit("emitBeforeDeleteFileFillFile", file)
      this.$emit("emitBeforeDeleteFile", file.id);
      if(this.awaitDeleteFile !== true) {
        this.axiosFileDelete(file.id).then(()=> {
          this.$emit("beforeFileDeleted");
          this.$emit("fileDeleted", file.id)
        });
      }
    },
    editModeFile(file, focusBool) {
    if (this.editPermission !== false) {
      this.fileNameCopy = file.name;
      this.editNameFile = "";
      for(let i=0; i<this.localFiles.length; i++) {
        this.localFiles[i].editMode = false;
      }
      file.editMode = true;
      this.keyRender++;
      if(focusBool == true) {
        setTimeout(()=> {

          let item = document.getElementById('editText'+file.id)
          console.log('editModeFile', item)
          if(item) {
              // this.$nextTick(()=> {
                  item.focus()
              const range = document.createRange();
              range.selectNodeContents(item);
              range.collapse(false);
              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(range);
            range.setStart(item, 0);
            range.setEnd(item, 2);
                // })
          }
        }, 600)

      }
    }

    },
    editmodeFalse(file) {
    if(this.editNameFile.length !==0 && this.fileNameCopy !== this.editNameFile) {
      this.changeNameFile(file);
      this.editNameFile = "";
      }
    else {
        file.name = this.fileNameCopy
      }
      for(let i=0; i<this.localFiles.length; i++) {
        this.localFiles[i].editMode = false;
      }
      this.keyRender++;
    },
    inputEditFile(e) {
      this.editNameFile = this.nameTask = e.target.innerText;
    },
  },
  mounted() {
  if(this.fileProps && Array.isArray(this.fileProps) === true) {
    this.localFiles = JSON.parse(JSON.stringify(this.fileProps));
    for(let i=0; i<this.localFiles.length; i++) {
      this.localFiles[i].editMode = false;
      this.localFiles[i].file = this.getUrlForFile(this.localFiles[i].file)
      this.localFiles[i].thumbnail = this.getUrlPreviewFile(this.localFiles[i])
    }
    console.log("this.fileProps")
    console.log(this.fileProps)
    console.log("this.localFiles")
    console.log(this.localFiles)
  }
    this.visibleAddFile ? this.nameFolder = "Attachments" : this.nameFolder = "Files"

  }
}
</script>

<style scoped lang="scss">
  .files-block-wrap {
  //padding-top: 20px;
  .name-block {
    display: flex;
    align-items: center;
    button {
      margin-left: 16px;
      position: relative;
      input {
        opacity: 0;
        width: 100% !important;
        height: 100% !important;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    padding-bottom: 12px;
  }
}

  .files-block {
  display: flex;
  align-items: flex-start;
    flex-wrap: wrap;
    position: relative;
    .file-type {
      ::-webkit-scrollbar
      {
        width: 0px;
        height: 0px;
        background-color: #F5F5F5;
      }

      ::-webkit-scrollbar-thumb
      {
        background: #BDCBD6;
        border-radius: 30px;
        width: 0px;
      }
      margin-bottom: 5px;
    margin-right: 5px;
    max-height: 95px;
      //overflow: hidden;
    position: relative;
    width: 66px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    .img-preview {
      border: 1px solid #DEE3EA;
    }
    img {
      border-radius: 3px;
      width: 48px;
      height: 48px;
    }
    p {
      min-height: 13px;
      max-height: 40px;
      overflow: auto;
      margin-top: 4px;
      text-align: center  ;
      width: 100%;
      box-sizing: border-box;
      word-wrap: break-word;
    }
    .option-button {
      display: none;
      position: absolute;
      top: -8px;
      right: 0;
    }
    &:hover {
      .option-button {
        display: flex;
      }
    }
    .editMode {
      text-decoration: underline;
    }
  }
}

  .view-file {
    .container {
      padding: 0;
    }
    display: flex;
    justify-content: center;
    z-index: 300;
    width: 100vw;
    height: calc(100vh - 56px);
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: rgba(44,44,44,0.95);
    &__top-panel {
      position: relative;

      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 61px;
    }
    .edit-file-name {
      &__button {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        transition: .1s linear;
        svg {
          margin-left: 8px;
          path {
            fill: #FFFFFF;
            transition: .1s linear;
          }
        }
        &:hover {
          color: #319FEF;
          svg {
            path {
              fill: #319FEF;
              transition: .1s linear;
            }
          }
        }
      }
      &__block {
        display: flex;
        width: max-content;
        input {
          background: #2C2C2C;
          border: 1px solid #4B4B4B;
          &:hover {
            border: 1px solid #FFFFFF;
          }
          &:focus {
            border: 1px solid #319FEF;
          }
          height: 32px;
          width: 254px;
          border-radius: 4px 0 0 4px !important;
        }
        button {
          box-sizing: border-box;
          background: #2C2C2C;
          border: 1px solid #4B4B4B;
          width: 32px !important;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            path {
              fill: #FFFFFF;
              transition: .1s linear;
            }
          }
          transition: .1s linear;
          &:hover {
            border: 1px solid #FFFFFF;
          }
          &:active {
            transition: 0s;
            border: 1px solid #319FEF;
            svg {
              path {
                transition: 0s;
                fill: #319FEF;
              }
            }
          }
          &:last-child {
            border-radius: 0 4px 4px 0;
          }
        }
      }
    }
    .block-scale-button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      &__block {
        display: flex;
        align-items: center;
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #4B4B4B;
          width: 32px;
          height: 32px;
          box-sizing: border-box;
          background-color: #2C2C2C;
          svg {
            path {
              fill: #FFFFFF;
              transition: .1s linear;
            }
          }
          transition: .1s linear;
          &:hover {
            border: 1px solid #FFFFFF;
          }
          &:active {
            transition: 0s;
            border: 1px solid #319FEF;
            svg {
              path {
                transition: 0s;
                fill: #319FEF;
              }
            }
          }
          &:nth-child(1) {
            border-radius: 4px 0 0 4px;
          }
          &:nth-child(3) {
            border-radius: 0px 4px 4px 0;
          }
        }
        p {
          box-sizing: border-box;
          border-top: 1px solid #4B4B4B;
          border-bottom: 1px solid #4B4B4B;
          background-color: #2C2C2C;
          height: 32px;
          width: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      display: flex;
      align-items: center;
      &>button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 24px;
        svg {
          path {
            //fill: #FFFFFF;
            transition: .1s linear;
          }
        }
        transition: .1s linear;
        &:hover {
          svg {
            path {
              fill: #319FEF;
            }
          }
        }
      }
      //padding-left: 48px;
    }
    .block-option-button {
      display: flex;
      align-items: center;
      button {
        svg {
          path {
            //fill: #FFFFFF;
            transition: .1s linear;
          }
        }
        transition: .1s linear;
        &:hover {
          svg {
            path {
              fill: #319FEF;
            }
          }
        }
        &:active {
          transition: 0s;
          svg {
            path {
              transition: 0s;
              fill: #319FEF;
            }
          }
        }
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
      }
      &__delete {
        margin-left: 24px;
      }
      &__close {
        margin-left: 64px;
      }
    }
    &__main {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: calc(100vh - 61px);
      padding-bottom: 61px;
      box-sizing: border-box;
      .block-with-file {
        position: relative;
        overflow: auto;
        width: calc(100% - (24px * 4));
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        img {
          //transform: scale(2);
          max-width: 100%;
          max-height: 100%;
          box-sizing: border-box;

        }
        video {
          width: 100%;
          height: 100%;
        }
        p {
          width: 287px;
          text-align: center;
          line-height: 24px;
        }
      }
      &>button {
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          path {
            //fill: #FFFFFF;
            transition: .1s linear;
          }
        }
        transition: .1s linear;
        &:active {
          transition: 0s;
          svg {
            path {
              transition: 0s;
              fill: #319FEF;
            }
          }
        }
      }
    }
  }

  .navigation-files-block {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    p {
      display: flex;
      align-items: center;
      svg {
        cursor: pointer;
        margin-right: 5px;
        opacity: 0.7;
        transition: .1s linear;
        &:hover {
          opacity: 1;
        }
      }
    }
    button {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .download-all {
      margin-right: 15px;
      margin-left: auto;
      svg {
        path {
          transition: .1s linear;
        }
      }
      &:hover {
        svg {
          path {
            fill: var(--color-blue-dark)
          }
        }
      }
      &:active {
        svg {
          path {
            transition: 0s linear !important;
            fill: var(--color-blue)
          }
        }
      }
      transition: 0.6s linear;
      transform: translateY(0);
    }

    .button-create-folder {
      svg {
        path {
          transition: .1s linear;
        }
      }
      &:hover {
        svg {
          &>path:nth-child(1) {
            stroke: var(--color-blue-dark)
          }
          &>path:nth-child(2) {
            fill: var(--color-blue-dark)
          }
        }
      }
      &:active {
        svg {
          path {
            transition: 0s linear !important;
          }
          &>path:nth-child(1) {
            stroke: var(--color-blue)
          }
          &>path:nth-child(2) {
            fill: var(--color-blue)
          }
        }
      }
    }
    .upload-file {
      margin-left: 15px;
      position: relative;
      cursor: pointer;
      input {
        cursor: pointer;
        opacity: 0;
        width: 100% !important;
        height: 100% !important;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
      }
      svg {
        position: relative;
        z-index: 0;
        path {
          transition: .1s linear;
        }
      }
      &:hover {
        svg {
          path {
            fill: var(--color-blue-dark)
          }
        }
      }
      &:active {
        svg {
          path {
            transition: 0s linear !important;
            fill: var(--color-blue)
          }
        }
      }
    }
  }

  .loader-file {
    z-index: 50;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    min-height: 97px;
    background-color: var(--color-bgc-page-white);
    /deep/ {
      .sk-fading-circle {
        width: 40px;
        height: 40px;
      }
    }
  }

  .load-button {
        -webkit-animation: bounce 0.6s linear infinite;
        animation: bounce 0.6s linear infinite;
    transform: translateY(0);

  }

  @keyframes bounce{
    0%, 20%, 60%, 100% {
      transform: translateY(0);
      transform: translateY(0);
    }

    40% {
      transform: translateY(-10px);
      transform: translateY(-10px);
    }

    80% {
      transform: translateY(-5px);
      transform: translateY(-5px);
    }
  }

  .small-svg {
    svg {
      transform: scale(0.8);
    }
    .download-all {
      margin-right: 5px;
    }
    .upload-file {
      margin-left: 5px;
    }
  }

  .dart-mode {
    .loader-file, .download-all, .upload-file {
      svg {
        path {
          fill: #FFFFFF;
        }
      }
    }
    .button-create-folder {

          svg {
            &>path:nth-child(1) {
              stroke: #FFFFFF;
            }
            &>path:nth-child(2) {
              fill: #FFFFFF;
            }
          }
      }
    .navigation-files-block {
      &>p {
        svg {
          opacity: 0.7;
          transition: .1s linear;
          path {
            fill: #FFFFFF;
          }
          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .bgc-gray {
    background-color: var(--color-bgc-page);
  }
  .formatTxt {
    background-color: var(--color-white);
    body {
      background-color: var(--color-white);
      color: var(--color-dark);
      pre {
        color: var(--color-dark);
      }
    }
  }
  /deep/ {
    .wrap-loader-local {
      background-color: rgba(44,44,44,0.95);
    }
  }
</style>